import { render, staticRenderFns } from "./PieTable.vue?vue&type=template&id=2edd0743&scoped=true"
import script from "./PieTable.vue?vue&type=script&lang=js"
export * from "./PieTable.vue?vue&type=script&lang=js"
import style0 from "./PieTable.vue?vue&type=style&index=0&id=2edd0743&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edd0743",
  null
  
)

export default component.exports